@if (milestone) {
<div class="event-container" (mouseleave)="toggleDropDown(false)">
	<div
		id="dashboardEventItem{{ milestone.type }}"
		class="dashboard-event-item"
		[ngClass]="{
			skeleton: componentDataLoading,
			'skeleton-reveal': !componentDataLoading
		}"
		(click)="onMilestoneClick(milestone!.type)"
		aria-hidden="true"
	>
		<!-- left side -->

		<div class="left-side">
			<div class="highlight-automation-container">
				@if(tppFundingScreenEnabled) {
				<app-highlight-automation [manualFlagStatus]="manualFlagStatus" [milestoneType]="milestone!.type" />
				}
			</div>
			<div class="flex flex-column">
				<div class="title" [attr.data-test]="milestone | milestoneTypes | lowercase">
					{{ milestone | milestoneTypes }}
				</div>
				<div class="subtitle" [attr.data-test]="milestone.date | suffixAndAbbreviatedDate | lowercase">
					@if( hasTimezoneFeature) {
					{{ milestone.date | suffixLocalTimezoneDate }} ({{ timeZoneShort }}) } @else {
					{{ milestone.date | suffixAndAbbreviatedDate }}
					}
				</div>
			</div>

			@if (hasBookingDate) {
			<span class="booking-border"></span>
			<div class="booking-container">
				<div class="column">
					<span class="title" [attr.data-test]="milestone?.group + '-booking' | lowercase">BOOKING DATE</span>
					<span class="subtitle" [attr.data-test]="milestone?.group + '-booking-date' | lowercase">
						@if( hasTimezoneFeature) {
						{{ milestone!.extraInfo!.netBookingDate | suffixLocalTimezoneDate }} ({{ timeZoneShort }}) }
						@else {
						{{ milestone!.extraInfo!.netBookingDate | suffixAndAbbreviatedDate }}
						}
					</span>
				</div>
			</div>
			}
		</div>

		<!-- Right side -->
		<div
			class="right-side"
			id="status-container-{{ milestone.type }}"
			*ngIf="milestone.status !== 'UNDEFINED' && milestonesSelection"
		>
			<div class="info-container" *ngIf="milestoneReport">
				<div class="amount column">
					<span class="title"> TOTAL PAYMENT </span>

					<span
						class="value"
						[attr.data-test]="milestone?.group + '-' + milestone?.type + '-total-value' | lowercase"
					>
						{{ milestoneReport.totalPayoutAmount.value | number : "1.2-2"
						}}{{ milestoneReport.totalPayoutAmount.currency | iso3CountryToCurrencySymbol }}
						<span
							*ngIf="milestoneReport.totalFailedAmount.value > 0"
							class="failed"
							[attr.data-test]="milestone?.group + '-' + milestone?.type + '-failed-value' | lowercase"
						>
							({{ milestoneReport.totalFailedAmount.value | number : "1.2-2"
							}}{{ milestoneReport.totalFailedAmount.currency | iso3CountryToCurrencySymbol }})
						</span>
					</span>
				</div>

				<div class="currency column" fxLayoutGap="8px">
					<span class="title"> PAYMENT. CCY </span>
					<span
						class="value"
						[attr.data-test]="milestone?.group + '-' + milestone?.type + '-currency-value' | lowercase"
					>
						{{ milestoneReport.totalPayoutAmount.currency }}
					</span>
				</div>
			</div>
			<div
				class="status-container"
				[ngClass]="{
					'complete-style': milestone.status === 'COMPLETE' || milestone.status === 'Completed',
					'inProgress-style': milestone.status === 'IN_PROGRESS' || milestone.status === 'In progress',
					'pending-style': milestone.status === 'PENDING' || milestone.status === 'Pending',
					'errors-style': milestone.status === 'ERROR' || milestone.status === 'Has errors',
					selected: showDropDown
				}"
				(click)="$event.stopPropagation()"
			>
				<mat-form-field (click)="toggleDropDown()" [formGroup]="milestoneStatusForm" appearance="fill">
					<input
						matInput
						[readonly]="true"
						type="text"
						class="status-input"
						[formControlName]="'milestoneStatus'"
						[value]="milestone?.status"
						[attr.data-test]="milestone?.group + '-' + milestone?.type + '-status' | lowercase"
					/>

					<app-icon
						matSuffix
						class="drop-file-trigger"
						[lineWidth]="'2.5'"
						[name]="'arrow-down'"
						[size]="'16'"
						[ngClass]="{ selected: showDropDown }"
					></app-icon>
				</mat-form-field>
			</div>
			<div class="more-container" (click)="$event.stopPropagation()">
				<button mat-icon-button class="more-button" [cdkMenuTriggerFor]="menu">
					<app-icon class="more-icon" [name]="'more'" [size]="'24px'" [lineWidth]="'1px'"></app-icon>
				</button>
			</div>
		</div>
	</div>
	<div class="status-options-container" *ngIf="showDropDown">
		<div
			class="status-options"
			[attr.data-test]="milestone?.group + '-' + milestone?.type + '-dropdown' | lowercase"
		>
			<div
				class="status-option"
				(click)="setStatusSelection(mil.value)"
				*ngFor="let mil of milestonesSelection; last as last"
			>
				<span
					id="options-center-{{ milestone.type }}"
					class="option-text"
					[ngClass]="{
						'complete-option': mil.value === 'COMPLETE',
						'inProgress-option': mil.value === 'IN_PROGRESS',
						'pending-option': mil.value === 'PENDING',
						'errors-option': mil.value === 'ERROR'
					}"
					[attr.data-test]="milestone?.group + '-' + milestone?.type + '-' + mil.text | lowercase"
					>{{ mil.text }}
				</span>
			</div>
		</div>
	</div>
	<ng-template #menu>
		<div class="sub-menu flex flex-column" cdkMenu>
			<button class="event-actions" cdkMenuItem (click)="openHistoryLog(); $event.stopPropagation()">
				<span class="button-text">
					<app-icon
						class="button-icon"
						[name]="'history-log'"
						[color]="'black'"
						[lineWidth]="'1px'"
						[size]="'24'"
					></app-icon>
					<span class="text-spacing">History Log</span>
				</span>
			</button>
		</div>
	</ng-template>
</div>
}
